// 使用者 名稱 uid 星塵資訊
import useCopy from '@/hook/useCopy';
import Image from 'next/image';
import { DEFAULT_USER_IMG } from '@/common/constant';

const UserInfo = ({ t, user }) => {
    const copy = useCopy();

    return (
        <div className="space-y-[12px] border-b-1 border-dashed border-black2 pb-[12px]">
            <div className="py-[10px] flex items-center gap-x-[14px]">
                <div className="img-box w-[70px] h-[70px] !overflow-visible">
                    {/* 頭像 */}
                    <Image
                        className={`rounded-[50%] ${
                            user?.avatarFrame ? '!w-[95%] set-center !h-[95%]' : ''
                        }`}
                        width={70}
                        height={70}
                        src={user?.image || DEFAULT_USER_IMG}
                        alt="thumbnail"
                    />

                    {user?.avatarFrame && (
                        <Image
                            className="absolute !w-[120%] !h-[120%] set-center !max-w-[unset] !z-[2] set-center !object-contain"
                            width={34}
                            height={34}
                            src={user?.avatarFrame}
                            alt="frame"
                        />
                    )}
                </div>

                <div className="space-y-[12px] text-left">
                    {/* 使用者名稱 */}
                    <p className="text-btn3b text-white line-clamp-2">{user?.nickname}</p>

                    {/* uid */}
                    <button
                        className="text-bd3n text-black3 opacity-[.8]"
                        onClick={() => copy(user?.uid)}
                    >
                        @{user?.uid}
                    </button>
                </div>
            </div>

            <div className="space-y-[6px]">
                <div className="flex between-center gap-x-[15px] text-white text-btn1">
                    <div className="flex items-center gap-x-[7px] py-[6px]">
                        <Image
                            className="relative bottom-[1px]"
                            width={26}
                            height={26}
                            src="/images/icon/icon_pedal.gif"
                            alt="icon"
                        />

                        <span>{t('NORMAL_MEMBER')}</span>
                    </div>

                    {/* 分隔線 */}
                    <span className="w-[1px] h-[14px] border-l-1 border-black2" />

                    {/* 登入天數 */}
                    <p>登入 {user?.achievement?.loginDays} 天</p>
                </div>

                {/* 進度條 */}
                <div className="w-full rounded-[40px] h-[4px] bg-purple1 bg-opacity-[.3] overflow-hidden flex">
                    <p className="bg-vPurple h-full w-0 rounded-[40px]" />
                </div>

                <p className="opacity-[.8] text-white text-bd3n">
                    {t('LEVEL')}
                    <span className="text-bd3b text-bou"> 100 </span>
                    {t('DUST')}
                </p>
            </div>
        </div>
    );
};

export default UserInfo;
